// Configuración de la API - React carga automáticamente el .env según NODE_ENV
export const API_URL = process.env.REACT_APP_API_URL || 'https://amissionhub.com/api/v1';



// Función para obtener la URL completa (maneja URLs relativas y absolutas)
export const getFullUrl = (url) => {
  if (!url) return '';
  
  // Si la URL ya es absoluta, devolverla tal cual
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Si REACT_APP_API_URL es relativa, mantenerla relativa
  if (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.startsWith('/')) {
    return url.startsWith('/') ? url : `/${url}`;
  }
  
  // Si es absoluta, construir URL completa
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  return `${baseUrl}${url.startsWith('/') ? '' : '/'}${url}`;
};

// Configuración de mapas
export const MAP_CONFIG = {
  defaultCenter: [-33.4489, -70.6693], // Santiago, Chile
  defaultZoom: 12,
  mapboxToken: process.env.REACT_APP_MAPBOX_TOKEN || 'your_mapbox_token_here'
};

// Configuración de autenticación
export const AUTH_CONFIG = {
  tokenKey: 'token',
  userKey: 'user',
  expirationKey: 'tokenExpiration',
  tokenLifetime: 24 * 60 * 60 * 1000 // 24 horas en milisegundos
};

// Configuración de notificaciones
export const NOTIFICATION_CONFIG = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true
};

// Configuración de misiones
export const MISSION_CONFIG = {
  statuses: [
    { value: 'PENDING', label: 'Pendiente', color: '#f59e0b' },
    { value: 'IN_PROGRESS', label: 'En Progreso', color: '#3b82f6' },
    { value: 'COMPLETED', label: 'Completada', color: '#10b981' },
    { value: 'CANCELLED', label: 'Cancelada', color: '#ef4444' }
  ]
};

// Configuración de objetivos de misión
export const MISSION_OBJECTIVES = {
  types: [
    { id: 'rgb', name: 'RGB Imaging', icon: 'camera' },
    { id: 'multispectral', name: 'Multispectral', icon: 'chart-area' },
    { id: 'thermal', name: 'Thermal Imaging', icon: 'temperature-high' },
    { id: 'lidar', name: 'LiDAR Scanning', icon: 'layer-group' },
    { id: 'hyperspectral', name: 'Hyperspectral', icon: 'rainbow' },
    { id: 'spraying', name: 'Crop Spraying', icon: 'spray-can' },
    { id: 'monitoring', name: 'Crop Monitoring', icon: 'eye' },
    { id: 'weed', name: 'Weed Detection', icon: 'seedling' },
    { id: 'disease', name: 'Disease Detection', icon: 'virus' },
    { id: 'irrigation', name: 'Irrigation Assessment', icon: 'water' }
  ]
};

// Configuración de tipos de cultivo
export const CROP_TYPES = {
  types: [
    { id: 'maiz', name: 'Maíz', icon: 'seedling' },
    { id: 'trigo', name: 'Trigo', icon: 'wheat' },
    { id: 'soja', name: 'Soja', icon: 'seedling' },
    { id: 'arroz', name: 'Arroz', icon: 'seedling' },
    { id: 'algodon', name: 'Algodón', icon: 'tshirt' },
    { id: 'cana', name: 'Caña de azúcar', icon: 'candy-cane' },
    { id: 'cafe', name: 'Café', icon: 'coffee' },
    { id: 'vinedo', name: 'Viñedo', icon: 'wine-glass-alt' },
    { id: 'olivo', name: 'Olivo', icon: 'tree' },
    { id: 'citricos', name: 'Cítricos', icon: 'lemon' },
    { id: 'palma', name: 'Palma aceitera', icon: 'tree' },
    { id: 'aguacate', name: 'Aguacate', icon: 'apple-alt' }
  ]
};